module.exports = __webpack_public_path__ + "static/media/cristal.07dcd9b2.png";